import { useContext, useEffect } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import Link from 'next/link'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'
import { BlogHeaderLinks } from '../../components/blogs/BlogHeaderLinks'
import { getArticleDateTime } from '../../utils/article-date-time'
import { BlogsList } from '../../components/blogs/BlogList'
import { blogsMaster } from '../../utils/sg-blogs-data'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../lib/service'
import { getWpHealthFitness, getWpNewHealthFitness, setWpHealthFitness, setWpNewHealthFitness } from '../../service/wp-blogs-store'

export async function getStaticProps() {

    const { modifiedDate, month, year } = getArticleDateTime();
    const fitnessBlogs = blogsMaster['health-fitness'].blogArray;
    const wpPosts = getWpHealthFitness().length > 0 ?  getWpHealthFitness() : await getWpPostsByCategory(6, "health-fitness");
    setWpHealthFitness(wpPosts)
    const wpNewPosts = getWpNewHealthFitness().length > 0 ?  getWpNewHealthFitness() : await getWpNewPostsByCategory(6, "health-fitness");
    setWpNewHealthFitness(wpNewPosts)

  return {
      props: {
        modifiedDate,
        month,
        year,
        fitnessBlogs,
        wpPosts,
        wpNewPosts
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const fitnessBlogs = props.fitnessBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts

  return (
    <>
      <Head>
        <title>Importance of Basal Metabolic Rate (BMR) in weight loss</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="What is BMR (Basal Metabolic Rate). Understanding your BMR could be the key to your fitness journey for a fitter body."/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/blogs/what-is-basal-metabolic-rate-BMR" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Importance of Basal Metabolic Rate (BMR) in weight loss`}/>
        <meta property="og:description" content="Why hiring a professional fitness trainer is important to see great results in weight loss and muscle growth. Personal trainers can help with healthy diet plans." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-25T07:30:46+00:00" />
        <meta property="article:modified_time" content="2025-01-04T07:30:46+00:00" />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/fitness1.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/fitness1.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/blogs/what-is-basal-metabolic-rate-BMR"/>
        <meta name="twitter:title" content={`Importance of Basal Metabolic Rate (BMR) in weight loss`}/> 
        <meta name="twitter:description" content="What is BMR (Basal Metabolic Rate). Understanding your BMR could be the key to your fitness journey for a fitter body."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/blogs/what-is-basal-metabolic-rate-BMR" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/blogs/what-is-basal-metabolic-rate-BMR"},"headline":"Importance of Basal Metabolic Rate (BMR) in weight loss","description":"What is BMR (Basal Metabolic Rate). Understanding your BMR could be the key to your fitness journey for a fitter body.","image":["https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/fitness1.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-25T07:30:46+00:00","dateModified":"2022-09-04T07:30:46+00:00"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Blogs","item":"https://www.stringssg.com/blogs"},{"@type":"ListItem","position":1,"name":"basal-metabolic-rate-BMR"}]}]}`
          }}
        />
      </Head>
      <div className='max-w-5xl mx-auto py-5 px-2'>
            <div className='space-y-2'>
                <h1 className='text-lg text-gray-500 font-semibold'>Importance of Basal Metabolic Rate (BMR) in weight loss</h1>
                <div className='text-gray-400 text-xs'>
                    <time dateTime="2022-08-25 00:00">August 25th 2022</time>
                </div>
            </div>
            <div className='py-2 text-gray-500 leading-8 space-y-2'>
                <div className='py-2'>
                    <h2 className='uppercase text-gray-400'>
                        What is BMR?
                    </h2>
                    <p className=''>
                    BMR is the amount of calorie your body burns in a day with doing nothing. Do not confuse BMR with BMI (Body Mass Index), they are completely different. Our body is like a machine and in order to operate, it needs energy in the form calories to operate, which is the fuel to our body. Our body not only burns calories while doing cardio or strength training, but also while we are just sitting or even even sleeping. Our brain also burn a significant amount of calories for it to function. So, calorie is burnt by just being idle, the total amount of calorie burnt in a day in such state is called BMR.
                    </p>
                </div>
                <div className='relative h-96 max-w-xl'>
                    <Image className='rounded-lg'
                            src={s3Static + "fitness1.jpg"}
                            fill
                            style={{objectFit: 'cover'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Benefits of personal trainer'
                    />          
                </div>
                <div className='py-2 space-y-2'>
                    <h2 className='uppercase text-gray-400'>
                        What is your BMR?
                    </h2>
                    <p>
                        BMR varies from person to person. You can use the tool on <a href="https://www.calculator.net/bmr-calculator.html" className='text-orange-600'>https://www.calculator.net/bmr-calculator.html</a> to get your approximate BMR. To be more accurate, you could try BMR measuring scales available in the market, but they could be expensive and may cost somewhere between $50 to $200, depending on how much accurate they can be. The other way is walk-in to a fitness center and check if they can calculate it for you, usually every modern fitness center has the machine.
                    </p>
                </div>
                <div className='py-2 space-y-2'>
                    <h2 className='uppercase text-gray-400'>
                        WHY KNOWING YOUR BMR IS IMPORTANT?
                    </h2>
                    <p>
                    You are bound to lose weight when your amount of calorie intake in a day is less than the calories burnt by your body in a day. A positive calorie deficit will cut down your weight and a negative calorie deficit will result in weight gain.
                    </p>
                    <p>
                    The math is: Calorie Deficit = BMR – Calorie intake in a day
                    </p>
                    <p>
                    So the higher your BMR is, the more you can eat and still not gain weight.
                    </p>
                </div>
                <div className='py-2 space-y-2'>
                    <h2 className='uppercase text-gray-400'>
                        CAN YOU INCREASE YOUR BMR?
                    </h2>
                    <p>
                        Yes, you can. It is proven that, the amount of muscle mass in your body is directly proportional to your BMR. So the target should be to increase your muscle mass. Adapting to strength training and adding sufficient protein to your diet can help increase or maintain muscle mass.
                    </p>
                </div>
                <div className='py-2 space-y-2'>
                    <h2 className='uppercase text-gray-400'>
                        WILL STARVING PUT YOU ON A CALORIE DEFICIT?
                    </h2>
                    <p>
                        Yes, not eating enough food can put you on a calorie deficit mode and you will lose weight, but in the long run your body gets used to it and brings down your BMR which may have adverse effect. So I do not recommend starving. What is advised is to top-up you calorie burnt by being active. You could add cardio or strength training to your daily habits based on your comfort level, while adding both is the best. This will also keep you on a calorie deficit mode without hampering your BMR or may increase your BMR as well.
                    </p>
                </div>
                <div className='py-2 space-y-2'>
                    <h2 className='uppercase text-gray-400'>
                        SHOULD I BE SELECTIVE ABOUT WHAT I EAT?
                    </h2>
                    <p>
                    100 grams of chocolate has around 546 calories while 100 grams of carrots is only 41 calories. So you can fill your stomach with low calorie food without starving, you just need to pick the right food. We would not recommend a very strict diet unless you want to compete, as sticking to a strict diet gets difficult in the long run and off course you want to use your taste buds gifted by god. Try to stay away from anything that is sweet, especially chocolates, ice-creams and soda as much as possible. Choose whole fruits over fruit juice. You could cheat on your meals once a while with your favorite food. Our Fitness Trainer can help with a proper diet plan that suits your life style.
                    </p>
                </div>
                <div className='py-2 space-y-2'>
                    <p>
                    Joining a gym and getting a professional personal training is probably your first step to guide you through the proper workout and diet plans to acheive a better BMR.
                    </p>
                </div>
                <div className='py-2 text-center'>
                    <Link href="/sg/personal-trainer" className='px-3 py-3 border border-amber-600 text-orange-600 rounded-lg'>
                            Personal trainer Singapore - get a tailored plan
                    </Link>
                </div>
            </div>
            <BlogsList blogs={fitnessBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
        </div>
        <div className='fixed bottom-0 w-full text-center text-lg'>
            <Link href="/sg/personal-trainer" prefetch={false} className='text-white py-3 bg-linear-to-tr from-amber-600 to-amber-400 block font-bold w-full'>
                    Personal trainer Singapore - get a tailored plan
            </Link>
        </div>
        <BlogHeaderLinks/>
        <Script 
            id="google-tagmanager-new"
            src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
            strategy="lazyOnload"
            onLoad={() => {              
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
            
                gtag('config', 'G-QD1HGGHDYJ');
            }} 
        />
    </>
  )
}
